import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "my_container" }
const _hoisted_2 = { class: "user_page" }
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "detail" }
const _hoisted_5 = { class: "detail" }
const _hoisted_6 = { class: "detail" }
const _hoisted_7 = { class: "detail" }
const _hoisted_8 = { class: "detail" }
const _hoisted_9 = { class: "actions" }
const _hoisted_10 = {
  key: 0,
  class: "dialog-backdrop"
}
const _hoisted_11 = { class: "dialog" }
const _hoisted_12 = { class: "dialog-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[5] || (_cache[5] = _createElementVNode("h1", { class: "title" }, "User Profile", -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.refreshAccessToken && _ctx.refreshAccessToken(...args))),
            class: "refresh-button"
          }, "Refresh Access Token")
        ]),
        _createElementVNode("div", _hoisted_3, [
          _cache[4] || (_cache[4] = _createElementVNode("h1", null, "User Details:", -1)),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h2", null, "Name: " + _toDisplayString(_ctx.name), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h2", null, "Last Name: " + _toDisplayString(_ctx.last_name), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("h2", null, "email: " + _toDisplayString(_ctx.email), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("h2", null, "role: " + _toDisplayString(_ctx.role), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("h2", null, "user Id: " + _toDisplayString(_ctx.uid), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showDeleteDialog = true)),
              class: "delete-button"
            }, "Delete Account")
          ])
        ])
      ])
    ]),
    (_ctx.showDeleteDialog)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _cache[6] || (_cache[6] = _createElementVNode("p", null, "Are you sure you want to delete your account? After deletion you will not be able to use any Carenuity service.", -1)),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("button", {
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.deleteAccount && _ctx.deleteAccount(...args))),
                class: "confirm-button"
              }, "Yes"),
              _createElementVNode("button", {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showDeleteDialog = false)),
                class: "cancel-button"
              }, "No")
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}